import { Col, Row, Typography } from "antd";
import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { useGetAdvertDuration30Day, useGetUnansweredMessages } from "../ServerSideStates";
import { RootState } from "store/Reducers";
import CustomNoData from "apps/Common/CustomNoData";
import { useEffect, useState } from "react";
import PageTitle from "apps/Common/PageTitle";

const UnReadMessages = () => {
  const { Text } = Typography;

  const { filter } = useSelector(
    (state: RootState) => state.competitorAnalysisRepor
  );
  const reports = useGetUnansweredMessages(filter);
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    if (reports?.data?.data) {
      const allData = reports.data.data;

      // Veriyi sadece iki sütun olacak şekilde düzenliyoruz
      const formattedData = [
        {
          name: "Ofisim",
          value: Math.round(allData.myOfficeUnansweredMessages),
        },
        {
          name: "Rakipler",
          value: Math.round(allData.competitorUnansweredMessages),
        },
      ];

      setData(formattedData);
    }
  }, [reports.data]);

  const COLORS = ["#006AFF", "#99C3FF"]; // Sütun renkleri

  return (
    <Row  gutter={[20,20]} className="!shadow-lg !rounded-md !p-4 !bg-gray-50">
      <Col span={24} className="!flex !justify-center md:!justify-start" >
          <PageTitle  textClassNames="!text-gray-400" title="Yanıtlanmayan Mesajlar" />
        </Col>
     

      {data.length > 0 ? (
        <Col xs={24}>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" barSize={40}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
          <p className="text-gray-500 text-center mt-2">
            Rakiplerle Fark{" "}
            <span className="text-green-600 font-semibold">
              {Math.round(reports?.data?.data?.differenceInMessages
)} Gün
            </span>
          </p>
        </Col>
      ) : (
        <div className="!h-[250px] !flex justify-center !w-full">
          <CustomNoData />
        </div>
      )}
    </Row>
  );
};

export default UnReadMessages;
